import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CancelledBenefsTableProps } from '../../../../../interfaces/props/Cancelamento/CancelledBenefsTableProps';
import './styles.css';
import { sxTable } from './sxProps';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';

const CancelledBenefsTable: React.FC<CancelledBenefsTableProps> = ({ data }) => {

  const { textStyleAccessibility, contrastBorderAccessibility, contrastColorAccessibility } = useAccessibility();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    ...{
      fontFamily: 'Unimed-Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
    },
    ...textStyleAccessibility
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F9F9F9'
    },
  }));

  return (
    <div>
      <TableContainer className='container-table' sx={sxTable} style={contrastBorderAccessibility} component={Paper}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <StyledTableCell><b>Nome</b></StyledTableCell>
              <StyledTableCell align="left"><b>Código</b></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, index) => (
              <StyledTableRow
                key={index}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <StyledTableCell component="th" scope="row">
                  {row.nome}
                </StyledTableCell>
                <StyledTableCell align="left">{row.codAntigoUsr}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default CancelledBenefsTable;